import React from "react";
import "./App.css";
import Home from "./home.js";

function App() {
    return (
        <React.Fragment>
            <div className="background">
                <Home />
            </div>
        </React.Fragment>
    );
}

export default App;
